import Vue from 'vue';
import AnchorLink from '~/components/Clickables/AnchorLink';
import AnchorRoute from '~/components/Clickables/AnchorRoute';
import Button from '~/components/Clickables/Button';
import Icon from '~/components/Icon';

Vue.component('AnchorLink', AnchorLink);
Vue.component('AnchorRoute', AnchorRoute);
Vue.component('Button', Button);
Vue.component('Icon', Icon);
